export default "__VITE_ASSET__tFRrrH6i__"